<div class="form-wrapper">
  <form [formGroup]="resetForm">
    <mat-form-field hideRequiredMarker="true">
      <mat-label>E-mailadres</mat-label>
      <input matInput autocomplete="email" type="email" formControlName="email" />
      @if (resetForm.controls.email.hasError('required')) {
        <mat-error>E-mailadres is verplicht.</mat-error>
      }
      @if (resetForm.controls.email.hasError('emailValidator')) {
        <mat-error>Vul een geldig e-mailadres in.</mat-error>
      }
    </mat-form-field>
    <div class="action-button-wrapper">
      <button type="button" mat-stroked-button routerLink="/auth/login"><mat-icon>arrow_back</mat-icon> Terug</button>
      <button
        mat-flat-button
        [class.spinner]="awaitingResponse()"
        [disabled]="awaitingResponse()"
        (click)="resetPassword()"
      >
        Reset wachtwoord
      </button>
    </div>
  </form>
</div>
